<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >Web Integration </h2>
        </div>
        <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a> 
        </div>
        <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='19' >
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe class="i-frame" src="https://www.youtube.com/embed/j5I8G4mhk50"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div>
       

        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="20">

            <label for="" class="mt-3 " >PayG serves as a crucial bridge
                between online
                businesses
                and
                the financial ecosystem, enabling secure and efficient online transactions.
                It
                acts
                as
                the virtual equivalent of a terminal, facilitating the
                transfer of
                payment
                information between a customer, their chosen payment method, and the
                merchant's
                bank.
                This process involves encryption and security measures to safeguard
                sensitive
                data
                during the transaction. </label>
            <label for="" class="mt-4" >Web integration is the process of
                linking the payment
                gateway
                to
                an online store, allowing businesses to accept online payments securely.
                This
                involves
                embedding the necessary code and APIs (Application Programming Interfaces)
                into
                the
                website's checkout process. Once integrated, customers can select their
                preferred
                payment method, and the payment gateway handles the rest – securely
                transmitting
                payment
                data, verifying the transaction, and confirming its success. Now, accepting
                online
                payments is simple, thanks to plug and play Integration options. PayG is the
                easiest
                solution for any developer. It can be integrated on any website with any
                stack.
                We
                have
                simple payment APIs with detailed documentation and SDKs for all major
                platforms.
                Accepting online payments is simple, thanks to plug and play Integration
                options.
                PayG
                is the easiest solution for any developer. It can be integrated on any
                website
                with
                any
                stack. We have simple payment APIs with detailed documentation and SDKs for
                all
                major
                platforms. </label>
            
        </div>
        <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="21">
            <h2 >Benefits of Web Integration </h2>
            <label for="" class="mt-3" >Web integration in a payment gateway
                company offers a
                host of
                benefits that enhance overall efficiency, security, and user experience for
                both
                businesses and their customers. </label>

            <ul>
                <li class="mt-3" ><b>Checkout experience:
                    </b>&nbsp;Integration provides a
                    consistent
                    and
                    branded checkout experience for customers. </li>

                <li class="mt-3" ><b>Enhanced Security: </b>&nbsp;Web
                    integration ensures
                    that
                    payment
                    information is securely transmitted between the customer, the merchant,
                    and
                    PayG.
                    This reduces the risk of data breaches and fraud, as sensitive data is
                    encrypted
                    and
                    protected during the transaction. </li>

                <li class="mt-3" ><b>Reduced Abandonment: </b>&nbsp;A
                    seamless checkout
                    process
                    can
                    reduce cart abandonment rates, as customers are less likely to get
                    frustrated
                    and
                    leave. </li>

                <li class="mt-3" ><b>Multiple Payment Options: </b>&nbsp;PayG
                    offers a range
                    of
                    payment
                    methods, such as credit/debit cards, digital wallets, and bank
                    transfers.
                    Web
                    integration allows businesses to offer these diverse options, catering
                    to
                    different
                    customer preferences and increasing the chances of completing a sale.
                </li>

                <li class="mt-3" ><b>Real-time Transaction Monitoring
                    </b>&nbsp;Integrated
                    payment
                    gateways provide real-time insights into transactions, allowing
                    businesses
                    to
                    track
                    sales, identify trends, and make informed decisions to optimize their
                    operations.
                </li>

                <li class="mt-3" ><b>Mobile-Friendly: </b>&nbsp;As more
                    customers shop on
                    mobile
                    devices,
                    integrated payment gateways are often optimized for mobile
                    responsiveness,
                    ensuring
                    a smooth payment experience on all devices. </li>
            </ul>
        </div>
    </div>
</div>
</div>
<div class="col-md-4   hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                Table of Contents:
            </h5>
         
        </div>
        <div class="col-md-12 mt-2" >
            <a href="#19">
                <div class="row">
                    <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">

                        <span style="cursor: pointer;" class="videoHover"
                            [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                            >
                            Web Integration </span>
                       
                    </div>
                </div>
            </a>
        </div>
        
        <div class="col-md-12 mt-2">
            <a href="#20">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">

                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            What is a Web Integration? </span>
                      
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="#21">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">

                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >Benefits
                            of
                            Web Integration </span>
                      
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-2">
            <a href="https://payg.in/developer.html" target="_blank">
                <div class="row">
                    <div class="col-md-2"> <img src="./assets/devloper.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="demoHover"
                            [ngClass]="{'demo':colors=='4'}" (click)="color('4')"
                            >
                            Developers</span>
                      
                    </div>
                </div>
            </a>
        </div>


    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
            <a [routerLink]="['/e-agrement']">    <button class="btn btn-color" (click)="menues('E-Agreement')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;E-Agreement
            </button>
           </a>

           
        </div>
        <div class="col-md-4    ">
            <a [routerLink]="['/introduction-reseller']"> <button class="btn btn-color" (click)="menues('Payment Link')"
                >Sales Partner
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button>
            </a>
        </div>
    </div>
</div>
</div>